const system = { 
	state: {
		"book_name": "",
		"notes": "",
		"area": null,
		"parent_name": null,
		"student_name": null,
		"teacher": null,
		"mobile": null,
		"checked": true
	},
	mutations: {
		'SET_BOOK_NAME': (state, book_name) => {
        	state.book_name = book_name
        },
		'SET_NOTES': (state, notes) => {
        	state.notes = notes
        },
		'SET_AREA': (state, area) => {
        	state.area = area
        },
		'SET_PARENT_NAME': (state, parent_name) => {
        	state.parent_name = parent_name
        },
		'SET_STUDENT_NAME': (state, student_name) => {
        	state.student_name = student_name
        },
		'SET_TEACHER': (state, teacher) => {
        	state.teacher = teacher
        },
		'SET_MOBILE': (state, mobile) => {
        	state.mobile = mobile
        },
		'SET_CHECKED': (state, checked) => {
        	state.checked = checked
        }
	}
}

export default system


// WEBPACK FOOTER //
// ./src/store/modules/system.js